/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const EyeIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
    >
      <path
        d="M20.9165 7.6C18.8965 2.91 15.0965 0 10.9965 0C6.89653 0 3.09653 2.91 1.07653 7.6C1.02146 7.72617 0.993042 7.86234 0.993042 8C0.993042 8.13766 1.02146 8.27383 1.07653 8.4C3.09653 13.09 6.89653 16 10.9965 16C15.0965 16 18.8965 13.09 20.9165 8.4C20.9716 8.27383 21 8.13766 21 8C21 7.86234 20.9716 7.72617 20.9165 7.6ZM10.9965 14C7.82653 14 4.82653 11.71 3.09653 8C4.82653 4.29 7.82653 2 10.9965 2C14.1665 2 17.1665 4.29 18.8965 8C17.1665 11.71 14.1665 14 10.9965 14ZM10.9965 4C10.2054 4 9.43204 4.2346 8.77425 4.67412C8.11645 5.11365 7.60376 5.73836 7.30101 6.46927C6.99826 7.20017 6.91904 8.00444 7.07339 8.78036C7.22773 9.55628 7.60869 10.269 8.1681 10.8284C8.72751 11.3878 9.44024 11.7688 10.2162 11.9231C10.9921 12.0775 11.7964 11.9983 12.5273 11.6955C13.2582 11.3928 13.8829 10.8801 14.3224 10.2223C14.7619 9.56448 14.9965 8.79113 14.9965 8C14.9965 6.93913 14.5751 5.92172 13.825 5.17157C13.0748 4.42143 12.0574 4 10.9965 4ZM10.9965 10C10.601 10 10.2143 9.8827 9.88539 9.66294C9.55649 9.44318 9.30014 9.13082 9.14877 8.76537C8.99739 8.39991 8.95779 7.99778 9.03496 7.60982C9.11213 7.22186 9.30261 6.86549 9.58231 6.58579C9.86202 6.30608 10.2184 6.1156 10.6063 6.03843C10.9943 5.96126 11.3964 6.00087 11.7619 6.15224C12.1273 6.30362 12.4397 6.55996 12.6595 6.88886C12.8792 7.21776 12.9965 7.60444 12.9965 8C12.9965 8.53043 12.7858 9.03914 12.4107 9.41421C12.0357 9.78929 11.527 10 10.9965 10Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
